import createElement from '../logical-components/createElement';
import mediaCard from './media-card';
// Global helpers
import svgs from './svgs';
import renderText from '../logical-components/renderText';
import internalEvents from '../logical-components/internalEvents';
var rememberMeServices = function (config, section, services) {
    var _a;
    var servicesWrapper = createElement('div');
    var events = internalEvents(config);
    if ((_a = section === null || section === void 0 ? void 0 : section.options) === null || _a === void 0 ? void 0 : _a.showServices) {
        return servicesWrapper;
    }
    if (services && services.length) {
        servicesWrapper.innerHTML = "<h3> ".concat(renderText('rememberMe.services'), " </h3>");
        services.forEach(function (service) {
            var _a;
            if ((_a = section === null || section === void 0 ? void 0 : section.views) === null || _a === void 0 ? void 0 : _a.serviceCard) {
                var ele = section.views.serviceCard({
                    data: service,
                    svgs: svgs,
                    renderText: renderText,
                    events: events,
                    wrapper: servicesWrapper,
                });
                if (typeof ele === 'string') {
                    servicesWrapper.innerHTML = ele;
                }
                else {
                    servicesWrapper.appendChild(ele);
                }
            }
            else {
                servicesWrapper.appendChild(mediaCard(service));
            }
        });
    }
    return servicesWrapper;
};
export default rememberMeServices;
